import React, { Fragment } from 'react';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { DATE_FORMAT } from '../../../../../../utils/dates/dateMethods';
import { getWomanOfReproductiveAge } from '../../../../../../utils/householdMember/getWomanOfReproductiveAge';
import { formatDate } from '../../../../../../utils/dates/date.utils';
import { normalizeNameOfPerson } from '../../../../../../utils/normalize/normalizeNameOfPerson';

// Constants

import { PREFERENCES_FOR_PREGNANT } from '../../../../../../constants/ssap/hhmTypes/dropdownOptions';


const PregnancyInfo = props => {
    
    const {
        currentlyPregnant,
        dueDateOfPregnancy,
        endDateOfPregnancy,
        evaluateForMedicaidIndicator,
        exchangeAndProgramNames: {
            exchangeChip,
            exchangeMedicaid,
            exchangeName
        },
        idx,
        isState,
        member,
        numberBabiesExpectedInPregnancy,
        pregnantIndicator,
        serverDate,
        stateCode
    } = props;
    
    if(!getWomanOfReproductiveAge(member, serverDate)) {
        return null;
    }

    const getDate = date => {
        if(date === null) {
            return date;
        }
        return formatDate(date, DATE_FORMAT);
    };

    const getMedicaidEvaluation = (value = true) => {
        // value is defaulted to true since evaluateForMedicaidIndicator is defaulted to true

        if (isState.ID) {
            const option = PREFERENCES_FOR_PREGNANT(stateCode).find(option => {
                return option.value === value;
            });

            return option ? option.text : null;
        }

        // the value is reversed because for Yes option stands false value and vise versa
        return !value;
    };

    const personName = normalizeNameOfPerson(member.name);

    const getPregnancyInformation = () => {
        switch(true) {
            case !pregnantIndicator:
                return (
                    <SummaryItem
                        textCode = 'common.is_pregnant'
                        value = { currentlyPregnant }
                        desc = {
                            [
                                [
                                    `taxHousehold.householdMember[${ idx }].specialCircumstances.currentlyPregnant`
                                ]
                            ]
                        }
                    />
                );

            case pregnantIndicator && !currentlyPregnant:
                switch(true) {
                    case !!endDateOfPregnancy:
                        return (
                            <Fragment>
                                <SummaryItem
                                    textCode = 'common.is_pregnant'
                                    value = { currentlyPregnant }
                                    desc = {
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].specialCircumstances.currentlyPregnant`
                                            ]
                                        ]
                                    }
                                />
                                <SummaryItem
                                    textCode = 'common.pregnancy_end_date'
                                    value = { getDate(endDateOfPregnancy) }
                                    ignoreIntl
                                    desc = {
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].specialCircumstances.endDateOfPregnancy`,
                                                getDate
                                            ]
                                        ]
                                    }
                                />
                            </Fragment>
                        );

                    case !endDateOfPregnancy:
                        return (
                            <SummaryItem
                                textCode = 'common.is_pregnant'
                                value = { currentlyPregnant }
                                desc = {
                                    [
                                        [
                                            `taxHousehold.householdMember[${ idx }].specialCircumstances.currentlyPregnant`
                                        ]
                                    ]
                                }
                            />
                        );
                    default:
                        return null;
                }

            case pregnantIndicator && currentlyPregnant:
                return (
                    <Fragment>
                        <SummaryItem
                            textCode = 'common.is_pregnant'
                            value = { currentlyPregnant }
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].specialCircumstances.currentlyPregnant`
                                    ]
                                ]
                            }
                        />
                        <SummaryItem
                            textCode = 'common.expected_number_of_babies'
                            value = { numberBabiesExpectedInPregnancy }
                            ignoreIntl
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].specialCircumstances.numberBabiesExpectedInPregnancy`
                                    ]
                                ]
                            }
                        />
                        <SummaryItem
                            textCode = 'common.pregnancy_due_date'
                            value = { getDate(dueDateOfPregnancy) }
                            ignoreIntl
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].specialCircumstances.dueDateOfPregnancy`,
                                        getDate
                                    ]
                                ]
                            }
                        />
                        <SummaryItem
                            textCode = 'ssap.input.legend.tax_credit_preference'
                            value = { getMedicaidEvaluation(evaluateForMedicaidIndicator) }
                            replacements = { {
                                personName,
                                exchangeChip,
                                exchangeMedicaid,
                                exchangeName
                            } }
                            desc = {
                                [
                                    [
                                        `taxHousehold.householdMember[${ idx }].evaluateForMedicaidIndicator`,
                                        getMedicaidEvaluation
                                    ]
                                ]
                            }
                        />
                    </Fragment>
                );
            default:
                return null;
        }
    };
    
    return (
        <Fragment>
            { getPregnancyInformation() }
        </Fragment>
    );
};

export default PregnancyInfo;